export default __webpack_public_path__ + "img/0a270e6d5b2b70ddda8fbdaf70caa631.svg";